"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions;
(function (actions) {
    actions["SET_USER"] = "SET_USER";
})(actions = exports.actions || (exports.actions = {}));
;
//# sourceMappingURL=interface.js.map